import { useNavigate } from "react-router-dom";

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

const openings = [
  {
    dept: "Engineering",
    deptKo: "개발",
    icon: "ri-code-s-slash-line",
    roles: [
      {
        title: "풀스택 개발자",
        type: "정규직",
        location: "서울 (재택 혼합)",
        tags: ["React", "TypeScript", "Supabase"],
        desc: "K-ArtPEN 플랫폼의 핵심 기능 개발 및 서비스 품질 향상을 함께 이끌어 나갑니다. 실시간 시뮬레이션 엔진 구현 경험 우대.",
      },
    ],
  },
  {
    dept: "Content & Education",
    deptKo: "콘텐츠 & 교육",
    icon: "ri-book-open-line",
    roles: [
      {
        title: "교육 콘텐츠 기획자",
        type: "정규직",
        location: "서울",
        tags: ["문화예술", "커리큘럼", "시나리오 기획"],
        desc: "문화예술 기업 경영 시뮬레이션 시나리오 및 학습 콘텐츠를 기획합니다. 예술 경영 또는 교육 기획 경험자 우대.",
      },
    ],
  },
  {
    dept: "Business",
    deptKo: "사업",
    icon: "ri-briefcase-line",
    roles: [
      {
        title: "기관 영업 · 파트너십",
        type: "정규직",
        location: "서울",
        tags: ["B2B 영업", "교육기관", "파트너십"],
        desc: "대학교, 문화예술 기관 등을 대상으로 K-ArtPEN 플랫폼 도입을 제안하고 장기적인 파트너십을 구축합니다.",
      },
    ],
  },
];

const values = [
  { icon: "ri-lightbulb-line", title: "자율과 책임", desc: "업무 방식과 일정을 스스로 설계합니다. 대신 결과에 집중합니다." },
  { icon: "ri-palette-line", title: "문화예술에 대한 진심", desc: "우리가 만드는 제품이 문화예술 생태계에 기여한다는 믿음으로 일합니다." },
  { icon: "ri-team-line", title: "작은 팀, 큰 임팩트", desc: "불필요한 위계 없이 각자의 전문성으로 제품을 만들어 갑니다." },
  { icon: "ri-seedling-line", title: "함께 성장", desc: "팀원의 성장이 곧 회사의 성장. 학습을 적극 지원합니다." },
];

const benefits = [
  "스톡옵션 부여 (직급별 차등)",
  "원격 근무 가능 (주 2~3일 출근)",
  "장비 지원 (MacBook 또는 동급 장비)",
  "도서·강의 구매 지원 (연 50만원)",
  "문화예술 행사 관람 지원",
  "유연 근무 (코어 타임 10:00~16:00)",
];

export default function CareersPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0C0C0E]" style={{ fontFamily: PD }}>
      {/* Nav */}
      <div className="sticky top-0 z-50 bg-[#0C0C0E]/95 backdrop-blur-sm border-b border-white/[0.05]">
        <div className="max-w-5xl mx-auto px-6 h-14 flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-[#888888] hover:text-[#CCCCCC] text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            K-ArtPEN
          </button>
          <span className="text-[#F2F2F2] text-sm font-semibold">채용 안내</span>
          <a
            href="mailto:eunhyun1@naver.com"
            className="text-[#7A9BFF] hover:text-[#9BB5FF] text-sm transition-colors whitespace-nowrap"
          >
            문의하기
          </a>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-16">
        {/* Hero */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-white/[0.04] border border-white/[0.08] text-[#7A9BFF] text-xs px-4 py-1.5 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4B6CF7] animate-pulse inline-block"></span>
            주식회사 툴뮤직 · 채용 중
          </div>
          <h1
            className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-6 leading-tight"
            style={{ fontFamily: PD }}
          >
            문화예술 교육의 미래를<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7A9BFF] to-[#9BB5FF]">
              함께 만들어 가요
            </span>
          </h1>
          <p className="text-[#666666] text-base max-w-xl mx-auto leading-relaxed">
            K-ArtPEN은 문화예술 기업 경영 교육을 혁신하는 에듀테크 스타트업입니다.<br className="hidden md:block" />
            함께 성장할 동료를 찾습니다.
          </p>
        </div>

        {/* Values */}
        <div className="mb-20">
          <h2 className="text-xl font-bold text-[#F2F2F2] mb-8 text-center">우리가 일하는 방식</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((v) => (
              <div key={v.title} className="bg-[#111112] border border-white/[0.06] rounded-xl p-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#4B6CF7]/10 border border-[#4B6CF7]/15 mb-4">
                  <i className={`${v.icon} text-[#7A9BFF] text-base`}></i>
                </div>
                <div className="text-[#F2F2F2] text-sm font-semibold mb-2">{v.title}</div>
                <div className="text-[#666666] text-xs leading-relaxed">{v.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Open Positions */}
        <div className="mb-20">
          <h2 className="text-xl font-bold text-[#F2F2F2] mb-8">채용 중인 포지션</h2>
          <div className="space-y-6">
            {openings.map((dept) => (
              <div key={dept.dept}>
                <div className="flex items-center gap-2 mb-3">
                  <i className={`${dept.icon} text-[#666666] text-sm`}></i>
                  <span className="text-[#888888] text-xs uppercase tracking-widest font-semibold">{dept.deptKo}</span>
                </div>
                <div className="space-y-3">
                  {dept.roles.map((role) => (
                    <div
                      key={role.title}
                      className="bg-[#111112] border border-white/[0.06] rounded-xl p-5 hover:border-white/[0.1] transition-colors"
                    >
                      <div className="flex flex-col md:flex-row md:items-center gap-4">
                        <div className="flex-1">
                          <div className="flex flex-wrap items-center gap-2 mb-2">
                            <span className="text-[#F2F2F2] text-sm font-semibold">{role.title}</span>
                            <span className="text-[10px] text-[#7A9BFF] bg-[#4B6CF7]/10 border border-[#4B6CF7]/20 px-2 py-0.5 rounded-full">
                              {role.type}
                            </span>
                          </div>
                          <p className="text-[#666666] text-xs leading-relaxed mb-3">{role.desc}</p>
                          <div className="flex flex-wrap items-center gap-3">
                            <div className="flex items-center gap-1 text-[#555555] text-[10px]">
                              <i className="ri-map-pin-line"></i>
                              {role.location}
                            </div>
                            <div className="flex flex-wrap gap-1">
                              {role.tags.map((tag) => (
                                <span
                                  key={tag}
                                  className="text-[9px] text-[#555555] bg-white/[0.04] border border-white/[0.06] px-2 py-0.5 rounded"
                                >
                                  {tag}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                        <a
                          href="mailto:eunhyun1@naver.com?subject=채용 지원"
                          className="shrink-0 px-5 py-2.5 bg-[#4B6CF7] hover:bg-[#5B7CF7] text-white text-xs font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                        >
                          지원하기
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* No opening? */}
          <div className="mt-8 bg-[#111112] border border-white/[0.06] rounded-xl p-6 text-center">
            <div className="text-[#555555] text-sm mb-2">원하는 포지션이 없나요?</div>
            <p className="text-[#666666] text-xs leading-relaxed mb-4">
              채용 공고 이외에도 뛰어난 분들의 지원을 언제나 환영합니다.<br />
              자유 양식으로 이력서와 포트폴리오를 보내주세요.
            </p>
            <a
              href="mailto:eunhyun1@naver.com?subject=자유 지원"
              className="inline-flex items-center gap-2 text-[#7A9BFF] hover:text-[#9BB5FF] text-sm transition-colors"
            >
              <i className="ri-mail-line"></i>
              eunhyun1@naver.com
            </a>
          </div>
        </div>

        {/* Benefits */}
        <div className="mb-16">
          <h2 className="text-xl font-bold text-[#F2F2F2] mb-8">복리후생</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {benefits.map((b) => (
              <div key={b} className="flex items-start gap-3 bg-[#111112] border border-white/[0.06] rounded-xl p-4">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#4B6CF7]/15 shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#7A9BFF] text-[10px]"></i>
                </div>
                <span className="text-[#777777] text-xs leading-relaxed">{b}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="border-t border-white/[0.05] pt-12 text-center">
          <p className="text-[#444444] text-sm mb-2">주식회사 툴뮤직 · K-ArtPEN</p>
          <a
            href="mailto:eunhyun1@naver.com"
            className="text-[#7A9BFF] hover:text-[#9BB5FF] text-sm transition-colors"
          >
            eunhyun1@naver.com
          </a>
        </div>
      </div>
    </div>
  );
}
